module.exports = __webpack_public_path__ + "fonts/VideoJS.46ac6629.eot";